var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14833_844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.851576 7.90425C0.851201 9.24856 1.2052 10.5612 1.87833 11.7181L0.787201 15.6711L4.8642 14.6104C5.99185 15.2195 7.25529 15.5387 8.5392 15.5388H8.54258C12.781 15.5388 16.2312 12.1166 16.233 7.91026C16.2338 5.872 15.4346 3.95535 13.9825 2.51336C12.5306 1.0715 10.5996 0.277023 8.54226 0.276093C4.30333 0.276093 0.853388 3.69811 0.851638 7.90425",
    fill: "url(#paint0_linear_14833_844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.577007 7.90177C0.576569 9.29445 0.943257 10.654 1.64038 11.8524L0.510132 15.9471L4.73332 14.8484C5.89694 15.4779 7.20707 15.8098 8.54019 15.8103H8.54363C12.9341 15.8103 16.5083 12.265 16.5101 7.90809C16.5109 5.79659 15.6829 3.81104 14.1789 2.3174C12.6747 0.823938 10.6747 0.000868217 8.54363 0C4.15238 0 0.578757 3.54481 0.577007 7.90177ZM3.09201 11.646L2.93432 11.3976C2.27144 10.3518 1.92157 9.14326 1.92207 7.90226C1.92351 4.28087 4.89376 1.33457 8.54613 1.33457C10.3149 1.33532 11.9771 2.01947 13.2274 3.26078C14.4776 4.5022 15.1655 6.15243 15.1651 7.9076C15.1634 11.529 12.1931 14.4757 8.54363 14.4757H8.54101C7.35269 14.475 6.18726 14.1584 5.17088 13.56L4.92901 13.4177L2.42288 14.0696L3.09201 11.646V11.646Z",
    fill: "url(#paint1_linear_14833_844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55251 4.59832C6.40339 4.26946 6.24645 4.26282 6.10464 4.25705C5.98851 4.25209 5.85576 4.25246 5.72314 4.25246C5.59039 4.25246 5.3747 4.30201 5.19239 4.49953C5.00989 4.69724 4.49564 5.17501 4.49564 6.14673C4.49564 7.11851 5.20895 8.05761 5.30839 8.18952C5.40795 8.32118 6.68545 10.3791 8.7087 11.1708C10.3902 11.8287 10.7324 11.6979 11.0973 11.6649C11.4623 11.632 12.2751 11.1872 12.4409 10.726C12.6068 10.2649 12.6068 9.86958 12.5571 9.78697C12.5073 9.70468 12.3746 9.65525 12.1755 9.55652C11.9764 9.45773 10.9978 8.9799 10.8153 8.91398C10.6328 8.84812 10.5001 8.81525 10.3674 9.01302C10.2346 9.21048 9.85345 9.65525 9.73726 9.78697C9.6212 9.919 9.50501 9.93544 9.30601 9.83665C9.10682 9.73755 8.46576 9.52924 7.7052 8.85643C7.11345 8.3329 6.71395 7.68638 6.59782 7.48862C6.4817 7.29116 6.58539 7.18412 6.6852 7.0857C6.77464 6.99721 6.88432 6.85507 6.98395 6.73978C7.0832 6.62443 7.11632 6.54214 7.1827 6.41042C7.24914 6.27857 7.21589 6.16322 7.1662 6.06443C7.11632 5.96564 6.72951 4.98884 6.55251 4.59832Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14833_844",
    x1: 773.078,
    y1: 1539.78,
    x2: 773.078,
    y2: 0.276093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14833_844",
    x1: 800.51,
    y1: 1594.71,
    x2: 800.51,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14833_844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.510132)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsappIcon.89aba6922d624667e06f1b584fdac4ad.svg";
export { ForwardRef as ReactComponent };